<template>
  <div>
    <!--位置监控-->
    <div style="
        display: flex;
        align-items: center;
        margin-top: 15px;
        margin-bottom: 10px;
      ">
      <div style="flex: 1">
        <span class="page_title">{{ $t("locateVehicle.page_title") }}</span>
        <span style="font-size: 12px; color: #ff8c00; margin-left: 30px"><i class="iconfont icon-icon_prompt2"
            style="font-size: 16px; margin-right: 4px"></i>{{ $t("locateVehicle.selectvehicles") }}</span>
      </div>
      <div>
        <el-checkbox v-model="checked" :label="$t('locateVehicle.autoRefresh') + '(15s)'"></el-checkbox>

        <el-button size="mini" style="margin-left: 30px" @click="onRefreshClick">{{ $t("public.refresh") }}</el-button>
      </div>
    </div>
    <div style="width: 100%; height: calc(100vh - 190px)">
      <div style="width: 100%; height: 100%;display: flex;">
        <div style="height: 100%;flex: 1;">

          <KingLongMap ref="map" :coordsType="9" @LoadCompleted="MapLoadCompleted" />
        </div>
        <div :style="{ width: infoCol + '%' }" style="height: 100%;">
          <vehicle_info ref="vehicleinfo" @hide="hideEvent" style="width: 100%;" />

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import KingLongMap from "@/components/KingLongMap";
import vehicle_info from "./components/vehicle_info";
import { VeicleLastGpsList } from "./vehicleLastGpsList";
import { mapState } from "vuex";
import settings from "@/settings";
import { HashTable } from "@/utils/HashTable";
import { bd09togcj02, gcj02tobd09, wgs84togcj02 } from "@/utils/lnglat"
export default {
  name: "locateVehicle",
  components: {
    KingLongMap,
    vehicle_info,
  },
  data() {
    return {
      checked: true,
      lastGpsInfo: undefined,
      monitorList: [],
      index: 0,
      mapCol: 100,
      infoCol: 0,
      vlist: undefined,
      timer: undefined,
      mapLoaded: false,
      monitor_vid: undefined,
      monitor_isover: false,
      monitor_info: undefined,
      currentGpsInfo: undefined,
    };
  },
  destroyed() {
    if (this.timer) clearInterval(this.timer);

    this.socketClient.DetachEvent(
      "GetVelLastGPSEx",
      this.socketClient.eventType.onGetVelLastGPSExAck
    );
  },
  created() {
    this.socketClient.AttachEvent(
      "GetVelLastGPSEx",
      this.socketClient.eventType.onGetVelLastGPSExAck,
      this.GetVelLastGPSExAck
    );
  },
  computed: {
    ...mapState({
      //   opened: state => state.app.sidebar.opened,
      selectedVehicles: (state) => state.app.vehicles.selectedVehicles,
    }),
  },
  watch: {
    selectedVehicles() {
      //一个一个的添加，10个就会下发10次，一次比一次多一条
     
      if (this.selectedVehicles.length == 0) {
        this.$refs.vehicleinfo.hide();

      }
      this.updateVehicleList();
    },
    monitorList() {
      this.getLastGps();
    },
    "$route.query.vid": {
      handler() {
       
        this.monitor_vid = this.$route.query.vid;
        this.monitor_isover = false;
        this.monitor_info = JSON.parse(localStorage.getItem("monitor_vehicle"));
      },
      immediate: true,
    },
  },

  methods: {
    MapLoadCompleted() {
      this.mapLoaded = true;
      if (this.lastGpsInfo) {
        this.lastGpsInfo.updateGps(this.currentGpsInfo);
      }
    },
    hideEvent() {
      this.infoCol = 0;
      this.mapCol = 100;


    },
    updateVehicleList() {
      //和原来的进行比较，判断哪个需要更新

      // this.monitorList = [];
      var data = [];
      this.selectedVehicles.forEach((element) => {
        if (element.treeLevel == 5) {
          if (this.vlist.contains(element.nodeValue)) {
            //存在，更新状态
            this.vlist.update(element.nodeValue, { ismonitor: 2 }); //已经存在的，不重复下发的
          } else {
            this.vlist.add(element.nodeValue, { ismonitor: 1 }); //不存在，要下发
          }
          // data.push(element.nodeValue)
        }
      });

      //把 1 的找出来，然后获取位置

      this.vlist.keys((v) => {
        var k = this.vlist.items(v);

        if (k.ismonitor == 1) {
          data.push(v);
        }
        if (k.ismonitor == 3) {
          //删除
          this.vlist.remove(v);
        }
        k.ismonitor = 3;
      });

      this.lastGpsInfo.updateVehicles(this.selectedVehicles);

      this.getLastGps(data);
      // this.monitorList = data;
    },
    onRefreshClick() {
      this.getLastGps();
    },
    getLastGps(data) {
      if (!data) {
        //data为空的时候，获取vlist里面的内容
        data = [];
        this.vlist.keys((v) => {
          data.push(v);
        });
      }

      if (
        this.socketClient &&
        this.socketClient.socket &&
        data &&
        data.length > 0
      )
        this.socketClient.socket.GetVelLastGPSExReq(data.length, data);
    },
    GetVelLastGPSExAck(param) {
      var _this = this;
    
      if (param && param.v_strParam_Json) {
        var gpsInfo = JSON.parse(param.v_strParam_Json);
     
        if (gpsInfo == undefined) return;

        //异常定位的判断
        if (
          !gpsInfo.Lon ||
          !gpsInfo.Lat ||
          gpsInfo.Lon > 180 ||
          gpsInfo.Lon < -180 ||
          gpsInfo.Lat > 90 ||
          gpsInfo.Lat < -90
        ) {
          return;
        }
        var t = gcj02tobd09(gpsInfo.Lon, gpsInfo.Lat)
        gpsInfo.Lon = t[0];
        gpsInfo.Lat = t[1];

        //如果地图还没有加载完成，等地图加载完成在处理
        if (!this.mapLoaded) {
          this.currentGpsInfo = gpsInfo;

        } else {
          this.currentGpsInfo = undefined;

          _this.lastGpsInfo.updateGps(gpsInfo);
        }
        //通过车辆树直接点击过来的车辆监控
        if (this.monitor_vid && this.monitor_vid == gpsInfo.VehicleID) {
          if (!this.monitor_isover) {
            this.monitor_isover = true;
            this.$bus.$emit("showOnMapEvent", {
              vehicleInfo: this.monitor_info,
              gpsInfo: gpsInfo,
            });
          }
        }
      }
    },
  },

  mounted() {
    const currentPath = this.$route.path
    // 从全局变量中取出对应路由的开始时间
    const startTime = settings.routeStartTime[currentPath]
    if (startTime) {
      // 计算耗时（mounted时组件已挂载到DOM，UI基础展示完成）
      const renderTime = Date.now() - startTime
   
      // 可选：上报到后端或日志系统
      // reportRenderTime(currentPath, renderTime)

      // 清除已计算的开始时间，避免重复计算
      delete settings.routeStartTime[currentPath]
    }

    var _this = this;
    this.$store.dispatch("app/openSideBar");
    this.monitorList = [];

    this.vlist = new HashTable();

    if (this.timer != null) clearInterval(this.timer);

    if (this.timer == null) {
      setInterval(() => {
        if (this.checked) {
          this.getLastGps();
        }
      }, 15 * 1000);
    }

    if (!this.lastGpsInfo) {
      this.lastGpsInfo = new VeicleLastGpsList();
      this.lastGpsInfo.init(this.$refs.map);
    }
    //he

    if (this.selectedVehicles.length > 0) {
      this.updateVehicleList();
    }

    //注册事件监听

    this.$bus.$on("showOnMapEvent", (param) => {
      // A发送来的消息

    
      if (this.$refs.vehicleinfo)
        this.$refs.vehicleinfo.show(
          param.vehicleInfo.vehicleName,
          param.vehicleInfo
        );
      //隐藏的时候
      this.infoCol = 30;
      this.mapCol = 70;
    });

    //注册监听事件，车辆树点击或者右键点击监控

    this.$bus.$on("onSingleVehicleMonitor", (param) => {
    
    });
    //获取参数传递过来的车辆信息
    //   if( this.$route.query.vid){
    //     //只有第一次有反馈
    //    this.monitor_vid=this.$route.query.vid;
 
    // //     this.monitor_isover=false;//还没有点击过
    // //     this.getLastGps([ this.monitor_vid])
    //     }
    //启动车辆监控
    //接口返回数据，模拟点击该辆车，
  },
};
</script>
<style></style>
